// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"64037a59","522":"7defdc61","582":"64037a59","596":"7defdc61","737":"7defdc61","829":"5e877987","951":"64037a59"}[chunkId] + ".chunk.css";
};